import { Component, ViewContainerRef } from '@angular/core';
import { LoggingService } from './+core/common/services/logging.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet (activate)="onActivate($event)"></router-outlet>'
})
export class AppComponent {
    public title = 'app works!';

    public constructor(private viewContainerRef: ViewContainerRef
        ,private loggingService: LoggingService
        ) { }

    onActivate(event) {
        window.scroll(0, 0);
        //or document.body.scrollTop = 0;
        //or document.querySelector('body').scrollTo(0,0)
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts